// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1PCpv","large":"styles_large__2dOiZ"};